let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6YDWW")).then(() => parcelRequire('aJCX7'));